import { GET_USER, SET_LOGIN_STATUS } from '../actions';

const homepage_reducer = (state, action) => {
  if (action.type === GET_USER) {
    return { ...state, user: action.payload };
  }
  if (action.type === SET_LOGIN_STATUS) {
    console.log('setting login status to: ', action.payload);
    return { ...state, isLoggedIn: action.payload };
  }
};

export default homepage_reducer;
